<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<style>
@import 'assets/css/style.css';
@import 'assets/css/common.css';
@import 'assets/css/header_footer.css';
</style>

<script>
export default {
  methods : {
    createTitleDesc : function(routeInstance){
         // タイトルを設定
        if(routeInstance.meta.title){
            var setTitle = routeInstance.meta.title;
            document.title = setTitle;
        } else {
            document.title = 'モデルハウスレコメンド小牧会場 | 中京テレビハウジング'
        }

        // メタタグdescription設定
        if(routeInstance.meta.desc){
            var setDesc = routeInstance.meta.desc;
            document.querySelector("meta[name='description']").setAttribute('content', setDesc)
        } else {
            document.querySelector("meta[name='description']").setAttribute('content', 'モデルハウス見学で、もう迷わない！効率的に見学するなら、モデルハウスレコメンドを使おう！好みや趣味に関する5つの質問から、あなたにピッタリなモデルハウスをご紹介いたします！')
        }
    } 
  },
   mounted : function(){
      var routeInstance = this.$route;
      this.createTitleDesc(routeInstance);
  },
  watch: { 
      // eslint-disable-next-line no-unused-vars
      '$route' (routeInstance, from) {
          this.createTitleDesc(routeInstance);
      }
  }
}
</script>
